import { render } from "./Navframe.vue?vue&type=template&id=d484417c&scoped=true"
import script from "./Navframe.vue?vue&type=script&lang=js"
export * from "./Navframe.vue?vue&type=script&lang=js"

import "./Navframe.vue?vue&type=style&index=0&id=d484417c&lang=scss&scoped=true"

import exportComponent from "/home/mmelillo/development/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d484417c"]])

export default __exports__